module.exports = {"imagePath":"burbujas-2_tex.png","width":1024,"name":"burbujas-2","SubTexture":[{"x":1,"y":1,"width":567,"name":"cortina03","height":572},{"x":1,"y":575,"width":618,"name":"cortina01","height":442}],"height":1024}


//////////////////
// WEBPACK FOOTER
// ./src/resource/burbujas/burbujas-2_tex.json
// module id = 402
// module chunks = 0